import { Box, HStack, Text, Link, Heading, Container, Flex, VStack, StackDivider } from "@chakra-ui/core";
import React from "react";
import VoteButtons from "./vote-buttons";
import Comment from "./comment";

const Post = ({ posts, post }) => {
  console.log(post);
  return (
    <HStack key={post.id} w="100%" alignItems="flex-start">
      <VoteButtons post={post} posts={posts} />
      <Box bg="gray.100" p={4} rounded="md" w="100%">
        <Heading>{post.title}</Heading>
        <Box bg="gray.100" p={4} rounded="md" w="100%">
            <Text>{post.body}</Text>
            {post.URL? <Text>URL: <Link href={post.URL}>{post.URL}</Link></Text> : null}
        </Box>
        <VStack
        divider={<StackDivider borderColor="gray.200" />}
        spacing={4}
        align="stretch"
        >
        <Container maxW="sm" centerContent>
            <Flex justifyContent="flex-end" w="100%" position="sticky" top={0}>
            <Comment post={post} posts={posts}/>
            </Flex>
        </Container>
        {post.comment && post.comment.map((comm) => {
            return (
                <Box bg="blue.100" p={2} rounded="md" w="100%">
                    {comm}
                </Box>
            )
        })}
        </VStack>
        
      </Box>
    </HStack>
  );
};

export default Post;